import {
  CatalogSearchState,
  CatalogSearchType,
} from 'b2b-apps/shop/catalog/redux/search/types';
import { RemoteRecord } from 'b2b-apps/shop/common/redux/RemoteRecord';
import { State } from 'b2b-apps/shop/common/redux/types';

const DEFAULT_QUERY = '*:*';
const DEFAULT_REQUESTED_QUERY = '*';

const getState = (state: State): CatalogSearchState => state.catalog.search;

const getSearch = (state: State): RemoteRecord<CatalogSearchType> => new RemoteRecord(getState(state));

const getQuery = (state: State): string => {
  const search = getSearch(state);

  if (search.data?.query && search.data.query !== DEFAULT_QUERY) {
    return search.data.query;
  }

  return '';
};

const getRequestedQuery = (state: State): string => {
  const search = getSearch(state);

  if (
    search.data?.requestedQuery
    && search.data.requestedQuery !== DEFAULT_REQUESTED_QUERY
  ) {
    return search.data.requestedQuery;
  }

  return '';
};

export {
  getQuery,
  getRequestedQuery,
  getSearch,
  getState,
};
